import { useGetProduct } from '@/shared/hooks/api/product'
import {
  isProductSharedEvidenceSlotFilled,
  useGetProductSharedEvidence,
} from '@/shared/hooks/api/productSharedEvidence'

export const PRODUCT_LEVEL_REQUIREMENTS_TOTAL = 3

export function useProductLevelRequirementsProgress(productId: string) {
  const { data: product, isLoading: isLoadingProduct } =
    useGetProduct(productId)
  const { data: sharedEvidence, isLoading: isLoadingSharedEvidence } =
    useGetProductSharedEvidence(productId)

  const hasProductDescription =
    product?.description != null && product.description.trim() !== ''
  const hasProductIdentification = isProductSharedEvidenceSlotFilled(
    sharedEvidence,
    'PRODUCT_IDENTIFICATION'
  )
  const hasManufacturerInformation = isProductSharedEvidenceSlotFilled(
    sharedEvidence,
    'MANUFACTURER_INFORMATION'
  )

  const completedCount = [
    hasProductDescription,
    hasProductIdentification,
    hasManufacturerInformation,
  ].filter(Boolean).length

  const isComplete = completedCount === PRODUCT_LEVEL_REQUIREMENTS_TOTAL

  return {
    product,
    sharedEvidence,
    isLoading: isLoadingProduct || isLoadingSharedEvidence,
    hasProductDescription,
    hasProductIdentification,
    hasManufacturerInformation,
    completedCount,
    isComplete,
    identificationFileName:
      sharedEvidence?.slots.find(
        (slot) => slot.slotKind === 'PRODUCT_IDENTIFICATION'
      )?.fileName ?? null,
    manufacturerFileName:
      sharedEvidence?.slots.find(
        (slot) => slot.slotKind === 'MANUFACTURER_INFORMATION'
      )?.fileName ?? null,
  }
}
